const linkPointer = (pointer) => ({ link: pointer.objectId });

export const buildEditorCanvasFormatPointerFields = (
  { format, formatDefault },
  { clearMissing = false } = {}
) => {
  const fields = {};

  if (formatDefault?.objectId) {
    fields.editor_project_formats_default_pointer = linkPointer(formatDefault);
  } else if (clearMissing) {
    fields.editor_project_formats_default_pointer = null;
  }

  if (format?.objectId) {
    fields.editor_project_formats_pointer = linkPointer(format);
  } else if (clearMissing) {
    fields.editor_project_formats_pointer = null;
  }

  return fields;
};

export const buildEditorCanvasTemplatePointerFields = (
  template,
  { clearOpposite = false } = {}
) => {
  if (!template?.objectId) return {};

  if (template.isGlobal === true) {
    return {
      editor_templates_default_pointer: linkPointer(template),
      ...(clearOpposite ? { editor_templates_pointer: null } : {}),
    };
  }

  return {
    editor_templates_pointer: linkPointer(template),
    ...(clearOpposite ? { editor_templates_default_pointer: null } : {}),
  };
};

export const getSelectedTemplateFromCanvas = (canvas) => {
  if (canvas?.editor_templates_pointer?.objectId) {
    return {
      ...canvas.editor_templates_pointer,
      isGlobal: false,
    };
  }

  if (canvas?.editor_templates_default_pointer?.objectId) {
    return {
      ...canvas.editor_templates_default_pointer,
      isGlobal: true,
    };
  }

  return undefined;
};
